import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptySet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 44,
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 44,
		height: 44,
		rx: 4,
		fill: "#EFEDEC"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M30.7776 14.6276L33.9001 11.5051L32.4946 10.0996L29.3721 13.2221C27.3792 11.5465 24.8075 10.5372 22.0001 10.5372C15.6697 10.5372 10.5378 15.6691 10.5378 21.9995C10.5378 24.8069 11.5471 27.3786 13.2227 29.3715L10.1001 32.4941L11.5056 33.8996L14.6282 30.777C16.6211 32.4525 19.1927 33.4618 22.0001 33.4618C28.3305 33.4618 33.4624 28.33 33.4624 21.9995C33.4624 19.1921 32.4531 16.6205 30.7776 14.6276ZM27.9602 14.634C26.3323 13.3151 24.2585 12.5249 22.0001 12.5249C16.7674 12.5249 12.5255 16.7668 12.5255 21.9995C12.5255 24.2579 13.3157 26.3317 14.6346 27.9596L27.9602 14.634ZM16.0401 29.3651L29.3657 16.0395C30.6846 17.6674 31.4747 19.7412 31.4747 21.9995C31.4747 27.2322 27.2328 31.4741 22.0001 31.4741C19.7418 31.4741 17.668 30.684 16.0401 29.3651Z",
		fill: "#A3A2A0"
	})]
});
export default SvgEmptySet;
